import request from '@/static/js/request'
import { getPlatform } from '@/static/js/zjs'

const appid = getPlatform().appid

export function getCurrentHoliday() {
  return request({
    method: 'get',
    url: '/mopa/api-answer-card/open/holiday/batch/get/active'
  }).then((res) => res.data)
}

export function getHolidayBookApplyInfo(data) {
  return request({
    method: 'post',
    url: '/mopa/api-answer-card/open/holidaybook/wx/apply/exists',
    data: {
      ...data,
      appid: appid
    }
  }).then((res) => res.data)
}
export function getHasFeedbackHolidayBook(data) {
  return request({
    method: 'post',
    url: '/mopa/api-answer-card/open/holidaybook/feedback/get',
    data: {
      ...data,
      appid: appid
    }
  }).then((res) => res.data)
}
export function saveFeedbackHolidayBook(data) {
  return request({
    method: 'post',
    url: '/mopa/api-answer-card/open/holidaybook/feedback/save',
    data: {
      ...data,
      appid: appid
    }
  }).then((res) => res.data)
}

// 根据isbn查询书籍 sn， appid
export function getHolidayHomeWorkList(params) {
  return request({
    method: 'get',
    url: '/mopa/api-answer-card/open/holidaybook/listBySn',
    params
  }).then((res) => res.data)
}

export function getLikeHolidayBookByGrade(data){
  return request({
    method: 'post',
    url: '/mopa/api-answer-card/open/holidaybook/guess/like/list',
    data
  }).then((res) => res.data)
}
